import mutations from './employability.mutations'
import actions from './employability.actions'
import getters from './employability.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
